import { fileShareFavoriteClick } from '@wix/bi-logger-wixlabs-ugc/v2';

export const biFileShareWidgetFavoriteClick = (props: any) => {
  const {
    instance_id,
    app_id,
    logger,
    visitor_id,
    comp_id,
    owner,
    file_id,
    file_name,
    file_owner,
    file_size,
    file_type,
    favorites_count,
    is_folder,
    views_count,
    file_owner_id,
  } = props;
  logger?.report(
    fileShareFavoriteClick({
      instance_id,
      app_id,
      visitor_id,
      comp_id,
      owner,
      file_id,
      file_name,
      file_owner,
      file_size,
      file_type,
      favorites_count,
      is_folder,
      views_count,
      file_owner_id,
    }),
  );
};
